import { Alert, Button, Stack, Typography } from "@mui/material";
import type { StackProps } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from "react-router";
import useHasPermisos from "@/features/auth/hooks/useHasPermisos";
import { Permiso } from "@/shared/types/permiso";
import { Dialog, useOpenModal } from "@/components/modal";
import { EmisorConfig } from "../utils/de-types";
import { SilentSubmitError } from "@/shared/notification";


const DIALOG_CODE = "emisorConfigRequerido";

export function EmisorConfigRequiredDialog() {
    return (
        <Dialog code={DIALOG_CODE} size="sm">
            <ConfigRequiredAlert sx={{ py: 0 }} />
        </Dialog>
    );
}

export function useCheckEmisorConfig() {
    const openModal = useOpenModal();

    return (config: EmisorConfig | null) => {
        if (!config?.establecimiento || !config?.puntoExpedicion) {
            openModal(DIALOG_CODE);
            throw new SilentSubmitError();
        }
    };
}

export function ConfigRequiredAlert({ sx }: { sx?: StackProps["sx"] }) {
    const navigate = useNavigate();
    const hasConfigPermisos = useHasPermisos(Permiso.ManageConfiguracionFacturacionElectronica);

    return (
        <Stack gap={3} alignItems="center" sx={{ py: 4, ...sx }}>
            <Alert severity="warning" sx={{ maxWidth: 600 }}>
                <Typography variant="h6" gutterBottom>
                    Configuración Requerida
                </Typography>
                <Typography variant="body2">
                    Para crear documentos electrónicos se necesita configurar el Establecimiento y el Punto de Expedición en esta computadora.
                </Typography>
                {hasConfigPermisos && (
                    <Button
                        variant="contained"
                        startIcon={<SettingsIcon />}
                        onClick={() => navigate("/configuracion/facturacion-electronica")}
                        sx={{ mt: 2 }}
                    >
                        Ir a Configuración
                    </Button>
                )}
            </Alert>
        </Stack>
    );
}
